import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface SkeletonProps {
  className?: string;
}

// Shimmering placeholder block. Sized via className (height/width).
export const Skeleton = ({ className }: SkeletonProps) => (
  <motion.div
    aria-hidden
    className={cn(
      "rounded-md bg-size-[200%_100%]",
      "bg-[linear-gradient(90deg,#EEF0F6_0%,#F6F7FB_50%,#EEF0F6_100%)]",
      className
    )}
    animate={{ backgroundPosition: ["200% 0", "-200% 0"] }}
    transition={{ duration: 1.6, repeat: Infinity, ease: "linear" }}
  />
);

interface SkeletonRowsProps {
  rows?: number;
  columns: number;
}

// Helper for table-body placeholders. Renders <tr><td>… with shimmer cells.
export const SkeletonRows = ({ rows = 5, columns }: SkeletonRowsProps) => (
  <>
    {Array.from({ length: rows }).map((_, rowIdx) => (
      <tr key={rowIdx} className="bg-white border-b border-[#F0F0F5] last:border-0">
        {Array.from({ length: columns }).map((_, colIdx) => (
          <td key={colIdx} className="py-4 px-6">
            <Skeleton className="h-4 w-full max-w-[180px]" />
          </td>
        ))}
      </tr>
    ))}
  </>
);
